/**
 * MASS + Creatine promo block.
 *
 * Adds a variant to the cart via /cart/add.json, then dispatches the theme's
 * `ajaxProduct:added` event so the cart drawer rebuilds and opens (see
 * CartDrawer in theme.js).
 *
 * Variant source (in priority order):
 *   1. The selected option's data-variant-id, when a [data-variant-select]
 *      dropdown is present (multi-variant products like MASS).
 *   2. The host element's data-variant-id (single fixed variant like Creatine).
 */
class MassCreatinePromo extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("[data-add-creatine]");
    this.buttonText = this.querySelector("[data-button-text]");
    this.select = this.querySelector("[data-variant-select]");
    this.fallbackVariantId = this.dataset.variantId;
    this.defaultLabel = this.button?.dataset.defaultLabel || "";
    this.successLabel = this.dataset.successLabel || "";

    this.button?.addEventListener("click", this.onClick.bind(this));
  }

  getVariantId() {
    if (this.select && this.select.selectedIndex !== -1) {
      return this.select.options[this.select.selectedIndex].getAttribute(
        "data-variant-id"
      );
    }
    return this.fallbackVariantId;
  }

  async onClick() {
    if (this.button.getAttribute("aria-disabled") === "true") return;

    const variantId = this.getVariantId();
    if (!variantId) return;

    this.button.setAttribute("aria-disabled", "true");
    this.button.classList.add("btn--loading");

    try {
      const response = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          note: "MassCreatinePromo: " + variantId,
        }),
      });
      const data = await response.json();

      if (data.status === 422) {
        console.error(data);
        return;
      }

      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", {
          detail: { product: data },
        })
      );

      if (this.successLabel && this.buttonText) {
        this.buttonText.textContent = this.successLabel;
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.button.classList.remove("btn--loading");
      this.button.setAttribute("aria-disabled", "false");
    }
  }
}

if (!customElements.get("mass-creatine-promo")) {
  customElements.define("mass-creatine-promo", MassCreatinePromo);
}
